<template>
    <div v-if="show">
        <!-- Top -->
        <div class="head border-b border-t py-[10px] px-[20px] bg-blue-700 border-gray-400">
            <div class="text-white xl:mx-auto font-bold">
                <div>強制險</div>
            </div>
        </div>
        <!-- / Top -->
        <div class="pb-6">
            <!-- Head -->
            <div class="bg-blue-200 py-[10px] px-[20px]">
                <div class="flex text-black justify-between xl:mx-auto font-bold">
                    <div>險種名稱 / 保障內容</div>
                    <div>保額</div>
                </div>
            </div>
            <!-- / Head -->

            <!-- Body -->
            <div class="px-[20px] pt-8">
                <!-- 21 -->
                <template v-if="insures['21']">
                    <div class="xl:mx-auto">
                        <FormInfoInsText 
                            :text="`21 ${ $store.state.ins21.name }`"
                            @click="onClickShowInsInfo('21')"
                        />
    
                        <div class="mt-6">
                            <div class="flex justify-between items-center mt-5">
                                <div> 每一人傷害 </div>
                                <div> {{ ins21InjuredCover }} </div>
                            </div>
    
                            <div class="flex justify-between items-center mt-5">
                                <div> 每一人失能及身故 </div>
                                <div> {{ ins21DeathCover }} </div>
                            </div>
                        </div>
    
                        <!-- Price -->
                        <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                            <div
                                v-if="insures['21'].IndirectPrem"
                                class="text-[14px] text-gray-600 text-left xl:mr-6"
                            >
                                定價＄
                                <span class="font-bold text-[20px]">
                                    {{ $monetary.convertToLocaleString(insures['21'].IndirectPrem) }}
                                </span>
                            </div>
                            <div class="text-[14px] text-right text-pink-800">
                                {{ priceText }}＄
                                <span class="font-bold text-[20px]">
                                    {{ $monetary.convertToLocaleString(insures['21'].InsPremium) }}
                                </span>
                            </div>
                        </div>
                    <!-- / Price -->
                    </div>
                </template>
                <!-- / 21 -->

                <!-- 147 -->
                <template v-if="insures['147']">
                    <div class="bg-blue-400 mt-2 mb-4 p-[20px] rounded-2xl xl:mx-auto">
                        <div class="flex items-center justify-between xl:mx-auto">
                            <div class="my-1 text-[16px] text-blue-700 font-bold">
                                附加險
                            </div>
                        </div>

                        <FormInfoInsText 
                            :text="`147 ${ $store.state.ins147.name }`"
                            @click="onClickShowInsInfo('147')"
                        />
    
                        <div class="mt-6">
                            <div class="flex justify-between items-center mt-5">
                                <div> 每一人傷害 </div>
                                <div> {{ ins147InjuredCover }} </div>
                            </div>
    
                            <div class="flex justify-between items-center mt-5">
                                <div> 每一人失能及身故 </div>
                                <div> {{ ins147DeathCover }} </div>
                            </div>
                        </div>
    
                        <!-- Price -->
                        <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                            <div class="text-[14px] text-pink-800 list-price xl:mr-6">
                                網路獨家
                            </div>
                            <div class="text-[14px] text-right text-pink-800">
                                {{ priceText }}＄
                                <span class="font-bold text-[20px]">
                                    {{ $monetary.convertToLocaleString(insures['147'].InsPremium) }}
                                </span>
                            </div>
                        </div>
                    <!-- / Price -->
                    </div>
                </template>
                <!-- / 147 -->

                <!-- 47 -->
                <template v-if="insures['47']">
                    <div class="xl:mx-auto">
                        <div class="flex justify-between mt-6 flex-wrap md:flex-nowrap">
                            <FormInfoInsText 
                                :text="`47 ${ $store.state.ins47.name }`"
                                @click="onClickShowInsInfo('147')"
                            />
                            <div class="mt-[10px] md:mt-0 py-[5px] bg-blue-700 rounded-full text-white text-center w-full md:w-[220px]">
                                需簽回要保書
                            </div>
                        </div>
    
                        <div class="mt-6">
                            <div class="flex justify-between items-center mt-5">
                                <div> 每一人傷害 </div>
                                <div> {{ ins47InjuredCover }} </div>
                            </div>
    
                            <div class="flex justify-between items-center mt-5">
                                <div> 每一人失能及身故 </div>
                                <div> {{ ins47DeathCover }} </div>
                            </div>
                        </div>
    
                        <!-- Price -->
                        <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                            <div
                                v-if="insures['47'].IndirectPrem"
                                class="text-[14px] text-gray-600 text-left xl:mr-6"
                            >
                                定價＄
                                <span class="font-bold text-[20px]">
                                    {{ $monetary.convertToLocaleString(insures['47'].IndirectPrem) }}
                                </span>
                            </div>
                            <div class="text-[14px] text-right text-pink-800">
                                {{ priceText }}＄
                                <span class="font-bold text-[20px]">
                                    {{ $monetary.convertToLocaleString(insures['47'].InsPremium) }}
                                </span>
                            </div>
                        </div>
                    <!-- / Price -->
                    </div>
                </template>
                <!-- / 47 -->
            </div>
            <!-- / Body -->
        </div>
    </div>
</template>

<script>
import FormInfoInsText from '@/components/forms/InfoInsText';
/**
  * 查看詳細內容-強制責任險
 */
export default {
    name: 'PolicyViewCompulsoryInsurance',
    components: {FormInfoInsText},
    props: {
        /**
         * 已投保項目
         */
        carInsures: {
            type: Array,
            default: () => { return []; }
        },
        /**
         * 是否已經試算
         */
        isCalculated: {
            type: Boolean,
            default: false
        }
    },
    emits: ['showInsInfo'],
    data() {
        /**
         * @param {Object} insures 有投保的險種
         * @param {Boolean} show 是否顯示此區塊
         */
        return {
            insures: {
                '21': null,
                '147': null,
                '47': null,
            },
            show: false
        };
    },
    computed: {
        // 21 強制險-每一人傷害
        ins21InjuredCover() {
            if (this.insures['21']) {
                return this.$insurance.getCoverText(this.$store.getters['ins21/injuredCoverOptionsValid'], this.insures['21'].InjuredCover.toString());  
            } else {
                return null;
            }
        },
        // 21 強制險-每一人失能及身故
        ins21DeathCover() {
            if (this.insures['21']) {
                return this.$insurance.getCoverText(this.$store.getters['ins21/deathCoverOptionsValid'], this.insures['21'].DeathCover.toString());
            } else {
                return null;
            }
        },
        // 147
        ins147InjuredCover() {
            if (this.insures['147']) {
                return this.$insurance.getCoverText(this.$store.getters['ins147/injuredCoverOptionsValid'], this.insures['147'].InjuredCover.toString());  
            } else {
                return null;
            }
        },
        // 147
        ins147DeathCover() {
            if (this.insures['147']) {
                return this.$insurance.getCoverText(this.$store.getters['ins147/deathCoverOptionsValid'], this.insures['147'].DeathCover.toString());
            } else {
                return null;
            }
        },
        // 47
        ins47InjuredCover() {
            if (this.insures['47']) {
                return this.$insurance.getCoverText(this.$store.getters['ins47/injuredCoverOptionsValid'], this.insures['47'].InjuredCover.toString());  
            } else {
                return null;
            }
        },
        // 47
        ins47DeathCover() {
            if (this.insures['47']) {
                return this.$insurance.getCoverText(this.$store.getters['ins47/deathCoverOptionsValid'], this.insures['47'].DeathCover.toString());
            } else {
                return null;
            }
        },
        // 依據是否試算過，顯示「網路優惠價」或「參考價」字樣
        priceText() {
            return this.isCalculated ? '網路優惠價' : '參考價';
        },
    },
    mounted() {
        // 顯示線上投保成功的內容
        this.setContent();
    },
    methods: {
        /**
         * 顯示線上投保成功的內容
         * 
         * @public
         */
        setContent() {
            _.forIn(this.insures, (value, key) => {
                this.insures[key] = _.find(this.carInsures, {InsType: key});
                if (this.insures[key]) this.show = true;
            });
            // this.insures['21'] = _.find(this.carInsures, { InsType: '21' });
            // if (this.insures['21']) this.show = true;
        },
        /**
         * 顯示險種介紹（有代碼的險種說明）
         * 
         * @param {String} insType 險種
         * @public
         */
        onClickShowInsInfo(insType) {
            /**
             * 顯示險種介紹（有代碼的險種說明）
             * @property {String} insType 險種
             */
            this.$emit('showInsInfo', insType);
        }
    }
};
</script>
